import { Button, TextField } from "@mui/material";
import plusIcon from "../assets/svgs/faqs/plus.svg";
import minusIcon from "../assets/svgs/faqs/minus.svg";
import iconAppImage from "../assets/images/icon-app.png";
import parentImage from "../assets/images/child-page/parent-image.png";
import contactUsImage from "../assets/images/child-page/contact-us.png";
import section2Image from "../assets/images/child-page/section2.png";
import section3Image from "../assets/images/child-page/section3.png";
import appStoreImage from "../assets/images/app-store.png";
import playStoreImage from "../assets/images/play-store.png";
import socialMediaImage from "../assets/images/social-media.png";
import "../styles/child-page.css";
import { faqData } from "src/data/faq-child-data";
import { useState } from "react";
import useApiServices from "src/api/useApiServices";
import { useForm } from "react-hook-form";
import FormProvider, { RHFTextField } from "src/components/hook-form";
import { enqueueSnackbar } from "notistack";

interface ChildPageProps {}

const ChildPage: React.FC<ChildPageProps> = () => {
  const [expandItemId, setExpandItemId] = useState<number>(1);
  const { usePostApi } = useApiServices();
  const methods = useForm({});
  const { handleSubmit } = methods;

  const { mutate: contactUs, isLoading: isLoadingContactUs } = usePostApi({
    url: "/contact",
    withSuccessNotistack: false,
    onSuccess: (data: any) => {
      enqueueSnackbar({
        variant: "success",
        message: data?.message,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    },
  });

  const onSubmit = handleSubmit((data: any) => {
    contactUs({
      ...data,
    });
  });
  return (
    <>
      <div className="header-child">
        <div className="header-navbar">
          <img
            src={iconAppImage}
            alt=""
            onClick={() => (window.location.href = "/child-page/")}
          />
          <div className="nav-link-child">
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "/child-page/")}
            >
              HOME
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#features")}
            >
              FEATURES
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#faqs")}
            >
              FAQS
            </h2>
            <h2
              className="h2-nav-link"
              onClick={() => (window.location.href = "#contact-us")}
            >
              CONTACT
            </h2>
          </div>
          <Button
            className="button-nav-link"
            onClick={() => (window.location.href = "/parent-page/")}
          >
            PARENT’S WEBSITE
          </Button>
        </div>

        <div className="header-contant-child">
          <img src={parentImage} alt="" className="img-parent-header" />
          <div className="header-contant-text">
            <h1 className="h1-header-contant-text-top">
              {"Talk, Laugh, and Learn with Your New Cartoon Friend!".toUpperCase()}
            </h1>
            <p className="p-header-contant-text-top">
              Have fun chatting, laughing, and discovering new things with your
              favorite cartoon character—learning has never been this exciting!
            </p>
          </div>
          <div className="button-buttom">
            <Button className="button-watch-tutorial">EXPLORE</Button>
            <Button
              className="button-download"
              onClick={() => (window.location.href = "#features")}
            >
              DOWNLOAD
            </Button>
          </div>
        </div>
      </div>

      {/* section 2 */}
      <div className="section2" id="features">
        <div className="left-section">
          <h2 className="h2-left-secion">
            {"Talk to Your Cartoon Friend".toUpperCase()}
          </h2>
          <p className="p-desc-left-secion">
            Say hello to your new best friend! 🎤
          </p>
          <p className="p-contant-left-secion">
            Chat, ask questions, and have fun conversations with a friendly
            cartoon character who’s always ready to talk.
          </p>
          <p className="p-contant-left-secion">
            Want to tell a joke? Ask about their favorite food? Just tap and
            talk—your friend is here to listen and chat with you anytime! 🎉💬
          </p>
          <div className="download-app">
            <Button
              onClick={() => {
                window.open(
                  "https://apps.apple.com/ae/app/darayish/id6743008504",
                  "_blank"
                );
              }}
            >
              <img src={appStoreImage} alt="" className="app-store-button" />
            </Button>
            <Button
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=org.misraj.darayishChild",
                  "_blank"
                );
              }}
            >
              <img src={playStoreImage} alt="" className="play-store-button" />
            </Button>
          </div>
        </div>
        <div className="right-section">
          <img src={section2Image} alt="" className="img-section2" />
        </div>
      </div>

      {/* section 3 */}
      <div className="section3">
        <div className="left-section3">
          <img src={section3Image} alt="" className="img-left-section3" />
        </div>
        <div className="right-section">
          <h2 className="h2-left-secion">
            {"Engaging Games For fun".toUpperCase()}
          </h2>
          <p className="p-desc-left-secion">
            Get ready for awesome adventures with fun games made just for you!
            🎉
          </p>
          <p className="p-contant-left-secion">
            Color, solve puzzles, and play exciting challenges with your
            favorite cartoon friend.
          </p>
          <p className="p-contant-left-secion">
            Every game is designed to be super fun and easy to play, helping you
            think, create, and explore new things! Are you ready to start
            playing? 🚀✨
          </p>
          <div className="download-app">
            <Button
              onClick={() => {
                window.open(
                  "https://apps.apple.com/ae/app/darayish/id6743008504",
                  "_blank"
                );
              }}
            >
              <img src={appStoreImage} alt="" className="app-store-button" />
            </Button>
            <Button
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=org.misraj.darayishChild",
                  "_blank"
                );
              }}
            >
              <img src={playStoreImage} alt="" className="play-store-button" />
            </Button>
          </div>
        </div>
      </div>
      {/* faqs */}
      <div className="faqs" id="faqs">
        <div className="header-section">
          <h2 className="custom-h2">FAQs</h2>
          <p className="custom-p">
            We have answered the most essential questions that might come to
            your mind
          </p>
        </div>
        {faqData?.en.map((item) => (
          <div className="faqs-question">
            <div className="faqs-header">
              <h4 className="h4-faqs-question">{item.title}</h4>
              <div>
                <Button onClick={() => setExpandItemId(item.id)}>
                  {expandItemId == item.id ? (
                    <img src={minusIcon} alt="" />
                  ) : (
                    <img src={plusIcon} alt="" />
                  )}
                </Button>
              </div>
            </div>
            <p
              className="p-faqs-question"
              style={{
                display: expandItemId == item.id ? undefined : "none",
                whiteSpace: "pre-line",
              }}
            >
              {item.description}
            </p>
          </div>
        ))}
      </div>
      {/* contact us */}
      <div className="contact-us" id="contact-us">
        <div className="header-section">
          <h2 className="custom-h2">Contact Us</h2>
          <p className="custom-p">
            We have answered the most essential questions that might come to
            your mind
          </p>
        </div>
        <div className="contact-us-contant">
          <div className="contact-us-img">
            <img src={contactUsImage} alt="" />
          </div>
          <div className="contact-us-form">
            <FormProvider methods={methods} onSubmit={onSubmit}>
              <RHFTextField
                label="Full Name"
                name="fullName"
                className="input-form-contact-us"
              />
              <RHFTextField
                label="Email"
                name="email"
                className="input-form-contact-us"
              />
              <RHFTextField
                label="Message"
                className="input-form-contact-us"
                name="message"
                multiline
                rows={6}
              />
              <Button className="button-form-contact-us" type="submit">
                Send Message
              </Button>
            </FormProvider>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="footer">
        <div className="footer-contant">
          <div className="footer-left">
            <img src={iconAppImage} alt="" />
            <p className="footer-text-left">
              © All rights reserved for Misraj Technology 2025
            </p>
          </div>

          <div className="footer-right">
            <h2 className="footer-text-right">FOLLOW US</h2>
            <img src={socialMediaImage} alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChildPage;
